import React from 'react';
//import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
//import useStyles from './Styles';

interface TopSalesProps {
    title: string,
    date?: string,
    primary: number,
    secondary?: number,
    primaryUnit: string,
    secondaryUnit?: string,
}

const TopSalesBox:React.FC<TopSalesProps> = (props)=> {
	//const classes = useStyles();
	return (
        <div style={{padding:"1em",border:"1px solid silver",position:"relative"}}>
            <Typography variant="subtitle2">{props.title}</Typography>
            {props.date &&
            <div style={{position:"absolute",top:"1.2em",right:"1.2em",fontSize:"80%",color:"gray"}}>{props.date}</div>
            }
            <div style={{textAlign:"right",paddingTop:"0.5em",fontSize:"160%"}}>{props.primary}{props.primaryUnit}</div>
            {props.secondaryUnit &&
            <React.Fragment>
                <Divider/>
                <div style={{textAlign:"right",paddingTop:"0.5em",fontSize:"100%"}}>{props.secondary}{props.secondaryUnit}</div>
            </React.Fragment>
            }
        </div>
    );
}

export default TopSalesBox;
